import "core-js/modules/es.array.index-of";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
import IconCancel from '@vip-activity/ui/components/icon/IconCancel.vue';
import RankService from '@/service/rank';
import { STATUS } from '../LightBrand/constant';
import setting from '../Rank/setting';
var ERRMSG = {
  '-2': '您已提交过该内容，请勿重复提交',
  '-11': '您的登录态已失效，请重新登录',
  '-11221': '您的登录态已失效，请重新登录',
  '-31221': '出了点小错误，请稍后重试',
  '-11224': '提交失败，请检查并输入恰当的内容',
  '-11223': '您当前账号无法提交灯牌信息，如有异议，请联系客服同学',
  3: '您暂时无法提交灯牌信息，请稍后重试',
  default: '出了点小错误，请稍后重试'
};
export default {
  components: {
    IconCancel: IconCancel
  },
  props: {
    disable: {
      type: Boolean,
      default: true
    },
    originalData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      text: setting.灯牌默认文案,
      status: STATUS.EMPTY,
      maxLength: 16,
      dirtyTextArr: [],
      setting: setting
    };
  },
  computed: {
    curLength: function curLength() {
      return this.text.length;
    },
    autoFocus: function autoFocus() {
      return !this.originalData;
    },
    enableEdit: function enableEdit() {
      return !this.isLiveEnd && this.status !== STATUS.CHECKING;
    },
    isChecking: function isChecking() {
      var _this$originalData;

      // eslint-disable-next-line
      return this.status === STATUS.CHECKING && ((_this$originalData = this.originalData) === null || _this$originalData === void 0 ? void 0 : _this$originalData.is_send_check);
    }
  },
  watch: {
    originalData: {
      handler: function handler(newV) {
        if (newV) {
          this.text = newV.content;
          this.status = newV.check_status;
        }
      },
      immediate: true
    }
  },
  methods: {
    checkMyLight: function checkMyLight() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.dirtyTextArr.indexOf(_this.text) >= 0)) {
                  _context.next = 3;
                  break;
                }

                _this.toast(ERRMSG['-11224']);

                return _context.abrupt("return", false);

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return RankService.checkLight({
                  content: _this.text
                });

              case 6:
                return _context.abrupt("return", true);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);

                _this.handleCheckError(_context.t0);

                return _context.abrupt("return", false);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 9]]);
      }))();
    },
    updateMyLight: function updateMyLight() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isLegal, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.checkMyLight();

              case 3:
                isLegal = _context2.sent;

                if (!isLegal) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 7;
                return RankService.updateLight({
                  person_comment: _this2.text
                });

              case 7:
                res = _context2.sent;
                console.log('res: ', res);

                _this2.toast('保存成功，请耐心等待审核');

                _this2.$emit('refreshMyLight');

                setTimeout(function () {
                  _this2.$emit('close');
                }, 1500);

              case 12:
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);
                console.log('err: ', _context2.t0);

                _this2.toast(ERRMSG.default);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 14]]);
      }))();
    },
    handleCheckError: function handleCheckError(err) {
      var _this3 = this;

      var res = err.res;

      if (res.ret === -11221 || res.ret === -11) {
        this.confirm({
          msg: ERRMSG[res.ret],
          confirmText: '重新登录',
          confirm: function confirm() {
            _this3.loginService.openLogin();
          }
        });
      } else if (res.ret === -11223) {
        this.confirm({
          msg: ERRMSG[res.ret],
          confirmText: '联系客服',
          confirm: function confirm() {
            _this3.openKefu();
          }
        });
      } else {
        if (res.ret === -2 || res.ret === -11224) {
          this.dirtyTextArr.push(this.text);
        }

        this.toast(ERRMSG[res.ret] || ERRMSG.default);
      }
    },
    handleInputResize: function handleInputResize() {
      if (document.activeElement.tagName === 'INPUT') {
        var formHeight = $(this.$el).height();
        var winHeight = $(window).height();

        if (winHeight <= formHeight) {
          $(this.$el).css('bottom', "".concat(winHeight - formHeight, "px"));
        } else {
          $(this.$el).css('bottom', 0);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {},
  mounted: function mounted() {
    var _this4 = this;

    if (env.isAndroid) {
      window.addEventListener('resize', this.handleInputResize);
      this.$once('hook:beforeDestroy', function () {
        window.removeEventListener('resize', _this4.handleInputResize);
      });
    }

    if (!this.originalData) {
      // 模拟拉起键盘
      this.$nextTick(function () {
        _this4.$refs.input.click();

        _this4.$refs.input.focus();
      });
    }
  }
};